module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp1_9005.c87a5e89.png";